import React,{useState,useEffect} from 'react'
import HeaderOfTDashComp from './subComponents/HeaderOfTDashComp'
import SidebarofTdash from './subComponents/SidebarofTdash'
import { attendanceDatateacher, headerpropst } from '../../../utils/DashboardApi/TeacherDashboardApi'
import { Button,Row,Col } from 'react-bootstrap'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import PillSmall from '../../subComponents/CustomSubComponents/PillSmall'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
const handleReqCorrection=()=>{

}
const TeaAttendanceComp = () => {
    const [startDate,setStartDate] = useState("")
    const [serial, setserial] = useState("");
    const [punchDate, setpunchDate] = useState("");
    const [officeTime, setofficeTime] = useState("");
    const [inTime, setinTime] = useState("");
    const [outTime, setoutTime] = useState("");
    const [status, setstatus] = useState("");
    const [attendanceresponse, setAttendanceresponse] = useState([]);
    const [attendanceCount, setattendanceCount] = useState([]);
    const [DateWiseAttResponse, setDateWiseAttResponse] = useState([]);
    const navigate = useNavigate();
    const [endDate,setEndtDate] = useState("")
    const  handleStartDate=async (myvalofstartdate)=>{
        
        
        if(myvalofstartdate != null){

            var stdtmonth = myvalofstartdate.$M + 1;
            var stdtfinal = myvalofstartdate.$y + '-'+ stdtmonth +'-'+ myvalofstartdate.$D;
            setStartDate(stdtfinal)

            if(endDate !== "")
            {
                const _SDate = new Date(stdtfinal);
                const _endTime = new Date(endDate);
                console.log(_SDate)
                console.log(_endTime)
                if (_SDate < _endTime) {
                    console.log(stdtfinal,endDate)
                    await fetchEmpAttendanceDateWise(stdtfinal,endDate);
                }
                
            }
        }
    }
    const headers2 = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "*",
      }
    
    const handleEndDate= async (myvalenddate)=>{
        if(myvalenddate != null){

            var stdtmonth = myvalenddate.$M + 1;
            var edtfinal = myvalenddate.$y + '-'+ stdtmonth +'-'+ myvalenddate.$D;
            setEndtDate(edtfinal)
            console.log(startDate)
            console.log(edtfinal.toLocaleString())
            if(startDate !== "")
            {
                const _SDate = new Date(startDate);
                const _endTime = new Date(edtfinal);
                console.log(_SDate)
                console.log(_endTime)
                if (_SDate < _endTime) {
                    console.log(typeof(startDate), typeof(edtfinal))
                    console.log(startDate,edtfinal)
                    await fetchEmpAttendanceDateWise(startDate,edtfinal);
                }
            }
        }
    }
    async function fetchEmpAttendanceDateWise(startDatevar,edtfinalvar){
        if (window.token == null) {
            navigate("/login");
        }   
        else{
            try {
                const response = await axios.get(
                    `https://localhost:7229/api/TeacherDashboard/CustomDateWiseAttendance?EmpId=${headerpropst.id}&startDate=${startDatevar}&endDate=${edtfinalvar}`, {
                        headers: {
                            'Authorization': 'bearer ' + window.token
                        },
                }
            )
            setAttendanceresponse(response.data);
            const myresponse2 = await axios.post('https://localhost:7229/api/TeacherDashboard/GetCountPresentLateAbsent', response.data );
                    setattendanceCount(myresponse2.data);
                    console.log(myresponse2)
            
            } catch (err) {
                if (err) {
                    console.error(err);
                }
            }
        }
    }
    useEffect(() => {
        if (window.token == null) {
            navigate("/login");
        }
        else {
            const fetchEmpAttendance = async () => {
                try {
                    const myresponse = await axios.get(
                        `https://localhost:7229/api/TeacherDashboard/GetCurrentMonthEmpAttendance?EmpId=${headerpropst.id}`, {
                            headers: {
                                'Authorization': 'bearer ' + window.token
                            },
                        }
                    )
                    console.log(myresponse.data)
                    setAttendanceresponse(myresponse.data);
                    const myresponse2 = await axios.post('https://localhost:7229/api/TeacherDashboard/GetCountPresentLateAbsent', myresponse.data );
                    setattendanceCount(myresponse2.data);
                    console.log(myresponse2)
                    
                } catch (err) {
                    if (err.response) {
                        console.error(err.response.data);
                        console.log(err.response.status);
                        console.log(err.response.header);
                    } else {
                        console.error(`Error: ${err.message}`);
                    }
                }
            };
            fetchEmpAttendance();
            //fetchEmpAttendanceCount();
            console.log(attendanceresponse);
        }
    }, []);
    
  return (
    <>
    <div className="teadashcomp">
            <SidebarofTdash/>
            <div className="rightpartcontentwrap">
            <HeaderOfTDashComp heading="Good Morning Farhana" myprops={headerpropst}/>
            <div className="tabPane">
            <div className="tabpaneheightadjust tabpanerightattandancetab">
                    <div className="atttabbox">
                    <Row>
                        <Col lg={8} className="m-auto">
                        <Row className='firstrow'>
                            
                            <Col  className="d-flex align-items-end">
                            
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    value={startDate}
                                    
                                    onChange={(newValue) => {
                                        handleStartDate(newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} error={false} />}
                                />
                                </LocalizationProvider>
                           
                            </Col>
                            <Col className="d-flex align-items-end">
                            
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    value={endDate}
                                    
                                    onChange={(newValue) => {
                                        handleEndDate(newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} error={false} />}
                                />
                                </LocalizationProvider>
                            </Col>
                            <Col className="d-flex align-items-end">
                                <Button className='reqcorrectionbutton' onClick={handleReqCorrection}>Request for correction</Button>
                            </Col>
                        </Row>
                        </Col>
                    </Row>
                        <Row>
                            <Col lg={12}>
                                    <div className="buttonview">
                                    <div className="flexwrap">
                                        <div className="totalpresentpill">
                                            <p>Total Present : {attendanceCount.Present}</p>
                                        </div>
                                        <div className="totalpresentpill totalabsentpill">
                                            <p>Total Absent : {attendanceCount.Absent}</p>
                                        </div>
                                        <div className="totalpresentpill totallatepill">
                                            <p>Total Late : {attendanceCount.Late}</p>
                                        </div>
                                        <div className="totalpresentpill totalearlyleave">
                                            <p>Total Present this : {attendanceCount.TotalPresent}</p>
                                        </div>

                                    </div>
                                </div>
                        </Col>
                                
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <table>
                                    <thead>
                                        <tr>
                                            {attendanceDatateacher.header.map((item,key)=>{
                                                    return (
                                                        <th>
                                                            {item.headeritem}
                                                            {
                                                                item.img?
                                                                <img src={item.img} alt="" />
                                                                
                                                                :
                                                                ""
                                                            }
                                                        </th>
                                                    )
                                                })
                                            }                                           
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                        //attendanceDatateacher.innerTableData.map((item,key)=>{
                            attendanceresponse?
                        attendanceresponse.map((item, key) => {
                          return (
                            <tr>
                              <td>
                                {/* {item.SL} */}
                                {item.serial}
                              </td>
                              <td>
                                {/* {item.date} */}
                                {item.punchDate}
                              </td>
                              <td>
                                {/* {item.schooltime} */}
                                {item.officeTime}
                              </td>
                              <td>
                                {/* {item.intime} */}
                                {item.inTime}
                              </td>
                              <td>
                                {/* {item.outtime} */}
                                {item.outTime}
                              </td>

                              <td>
                                {item.status == "Present" ? (
                                  <PillSmall
                                    class={item.type}
                                    fontsize="12px"
                                    text={item.status}
                                    bg="rgba(0, 202, 85, 0.05)"
                                    textcolor="rgba(0,202,85, 1)"
                                  />
                                )
                                 : item.status == "Late" ? (
                                  <PillSmall
                                    class={item.type}
                                    fontsize="12px"
                                    text={item.status}
                                    bg=" rgba(255, 173, 0, 0.05)"
                                    textcolor="rgba(255, 173, 0, 1)"
                                  />
                                ) 
                                // : item.type == "Early Leave" ? (
                                //   <PillSmall
                                //     class="Earlyleave"
                                //     fontsize="12px"
                                //     text={item.type}
                                //     bg="rgba(100, 158, 255, 0.05)"
                                //     textcolor="rgba(100, 158, 255, 1)"
                                //   />
                                // )
                                 : (
                                  ""
                                )}
                              </td>
                            </tr>
                          );
                        })
                        :""
                      }
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </>
  )
}

export default TeaAttendanceComp